import React, { useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Label } from "@amzn/stencil-react-components/text";
import { Select } from "@amzn/stencil-react-components/form";
import useArb from "../../../../hooks/use-arb";
import {
  AttachmentType,
  TEMPORARY_CONSULAR_RESIDENCE_VISA_OFFICIAL_APPROVAL_INM_FMM,
  TEMPORARY_RESIDENCE_STUDENT_CARD_INM_WORK_AUTHORIZATION,
} from "../models";

export const DocumentUploadDropdown = () => {
  const bundle = useArb("HVHChecklistPantherResource");
  const history = useHistory();

  const { requisitionId, applicationId } = useParams<{
    applicationId: string;
    requisitionId: string;
  }>();

  const options = [
    {
      name: bundle.getMessage("Checklist-Document-Mexican-Passport"),
      type: AttachmentType.MEXICAN_PASSPORT,
    },
    {
      name: bundle.getMessage("Checklist-Document-Consular-Identification-Card"),
      type: AttachmentType.CONSULAR_IDENTIFICATION_CARD,
    },
    {
      name: bundle.getMessage("Checklist-Document-Voter-Card"),
      type: AttachmentType.VOTER_CARD,
    },
    {
      name: bundle.getMessage("Checklist-Document-Military-Service-Card"),
      type: AttachmentType.MILITARY_SERVICE_CARD,
    },
    {
      name: bundle.getMessage("Checklist-Document-Mexican-Birth-Certificate"),
      type: AttachmentType.MEXICAN_BIRTH_CERTIFICATE,
    },
    {
      name: bundle.getMessage("Checklist-Document-Temporary-Residence-Card"),
      type: AttachmentType.TEMPORARY_RESIDENCE_CARD,
    },
    {
      name: bundle.getMessage("Checklist-Document-Temporary-Resident-Student-Card-INM-Work-Authorization"),
      type: TEMPORARY_RESIDENCE_STUDENT_CARD_INM_WORK_AUTHORIZATION,
    },
    {
      name: bundle.getMessage("Checklist-Document-Permanent-Residence-Card"),
      type: AttachmentType.PERMANENT_RESIDENCE_CARD,
    },
    {
      name: bundle.getMessage("Checklist-Document-Naturalization-Certificate"),
      type: AttachmentType.NATURALIZATION_CERTIFICATE,
    },
    {
      name: bundle.getMessage("Checklist-Document-Temporary-Consular-Residence-Visa-INM-FMM"),
      type: TEMPORARY_CONSULAR_RESIDENCE_VISA_OFFICIAL_APPROVAL_INM_FMM,
    },
  ];

  const chooseAnOption = bundle.getMessage("Checklist-Document-Choose-An-Option");

  const renderOption = (option: any) => (
    <Row gridGap="S200" alignItems="center">
      {option.name}
    </Row>
  );

  const renderNativeOption = (option: any) => `${option.name}`;

  const renderSelectedValue = (option: any) => `${option.name}`;

  const valueAccessor = (option: any) => option.name;

  const onChange = useCallback(
    (option: any) => {
      const url = `/checklist/tasks/document/${requisitionId}/${applicationId}/${option.type}/false`;
      url.startsWith("http") ? window.location.assign(url) : history.push(url);
    },
    [history]
  );

  return (
    <Col gridGap={16}>
      <Label htmlFor="doc-upload-selector-1" id="doc-upload-selector-label-1"></Label>
      <Select
        id="doc-upload-selector-1"
        labelId="doc-upload-selector-label-1"
        placeholder={chooseAnOption}
        options={options}
        renderOption={renderOption}
        renderNativeOption={renderNativeOption}
        renderSelectedValue={renderSelectedValue}
        valueAccessor={valueAccessor}
        onChange={onChange}
      />
    </Col>
  );
};
